/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferOutName
 */
export interface OfferOutName {
    /**
     * 
     * @type {string}
     * @memberof OfferOutName
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OfferOutName
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof OfferOutName
     */
    modificationDate: Date;
}

export function OfferOutNameFromJSON(json: any): OfferOutName {
    return OfferOutNameFromJSONTyped(json, false);
}

export function OfferOutNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferOutName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function OfferOutNameToJSON(value?: OfferOutName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


